export const isChromelessPath = (): boolean => location.pathname.includes('/chromeless')
